function setSameHeight(){
    $('[data-sameheight-childs]').each(function(){
        var $parent = $(this);
        var arrChildren = $parent.data('sameheight-childs').split(',');
        $.each(arrChildren, function(i, e){
            var intMaxHeight = 0;
            $parent.find(e).each(function(iChild, eChild){
                $(eChild).css({
                    height: 'auto'
                });
                var intHeight = $(eChild).height();
                intMaxHeight = (intHeight > intMaxHeight ? intHeight : intMaxHeight);
            });
            $parent.find(e).each(function(iChild, eChild){
                $(eChild).css({
                    height: intMaxHeight
                });
            });
        });
    });
}

function setSameHeightAuto(){
    $('[data-sameheight-childs]').each(function(){
        var $parent = $(this);
        var arrChildren = $parent.data('sameheight-childs').split(',');
        $.each(arrChildren, function(i, e){
            $parent.find(e).each(function(iChild, eChild){
                $(eChild).css({
                    height: 'auto'
                });
            });
        });
    });
}